import { ElementRef, Directive, Renderer2 } from '@angular/core';
import { AuthenticationService } from 'iui-iconectiv-lib';
import { Roles } from './activities';

@Directive({
  selector: '[appRo]'
})
export class ReadonlyByRoleOnlyDirective {

  name: string;

  constructor(private el: ElementRef, private renderer: Renderer2, private authService: AuthenticationService) {
    
  }
}
